import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { InfoIcon } from './icons'
import { MCudaTooltip } from './CudaTooltip';
import classNames from 'classnames';

const styles = {
    container: {        
        backgroundColor: '#FFFFFF',
        position: 'relative'
    },
    border: {
        border: '1px solid #DDDDDD',
        borderRadius: 2,
    },
    padding: {
        padding: "0 15px"
    },
    shadowed: {
        boxShadow: "0 2px 5px 0 rgba(0,0,0,0.26), 0 2px 10px 0 rgba(0,0,0,0.16)"
    },
    overlay: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'white',
        opacity: 0.7,
        zIndex: 10
    },
    loadingAnimation: {
        alignSelf: 'center',
    }
};

const Box = ({ classes, className, children, header, subHeader, loadingAnimation = false, loadingAnimationSize = 40, shadowed = false, padding = false, disabled = false, border= true }) => {
    const outerClass = classNames({
        [classes.container]: true,
        [classes.border]: border,
        [className]: className,
        [classes.shadowed]: shadowed,
        [classes.padding]: padding
    })
    return (
        <div className={outerClass}>
            {loadingAnimation &&
                <div className={classes.overlay}>
                    <div className={classes.loadingAnimation}>
                        <CircularProgress size={loadingAnimationSize} />
                    </div>
                </div>
            }
            {disabled &&
                <div className={classes.overlay}></div>
            }
            {children}
        </div>
    );
};

export default withStyles(styles, { name: 'Box' })(Box);


const boxHeaderStyles =
    {
        container: {
            display: 'flex',
            padding: '20px 25px'
        },
        headerText: {
            fontSize: '20px',
            fontWeight: 300,
            lineHeight: '24px',
            color: 'rgba(0,0,0,0.87)',
            padding: '0px 20px 2px 0px'
        },
        subHeaderText: {
            fontSize: 12,
            lineHeight: '14px',
            color: '#999999',
        },
        bold: {
            fontWeight: 'bold'
        },
        headerContent: {
            flex: 1
        },
        titleContainer: {
            display: 'flex'
        },
        tooltipContainer: {
            marginLeft: '8px'
        }
    };


const BoxHeaderComponent = ({ classes, children, header, subHeader, tooltip, bold = false, ...other }) => {
    const textClass = classNames({
        [classes.headerText]: true,
        [classes.bold]: bold
    });
    return (
        <div className={classes.container}>
            <div className={classes.titleContainer}>
                <div>
                    <div className={textClass}>
                        {header}
                        {tooltip &&
                            <span className={classes.tooltipContainer}>
                                <MCudaTooltip
                                    title={tooltip}                                    
                                >
                                    <InfoIcon />
                                </MCudaTooltip>
                            </span>
                        }
                    </div>
                    {subHeader &&
                        <div className={classes.subHeaderText}>
                            {subHeader}
                        </div>
                    }
                </div>                
            </div>
            <div className={classes.headerContent}>
                {children}
            </div>
        </div>
    );
};

BoxHeaderComponent.propTypes = {
    header: PropTypes.string,
    subHeader: PropTypes.string,
};


export const BoxHeader = withStyles(boxHeaderStyles, { name: 'BoxHeader' })(BoxHeaderComponent);